'use client'

import { IPost } from '@/api/interfaces/IPost'
import { PostApi } from '@/api/post'
import { WithT } from '@/locales/types'
import { PaginatedComment } from '@/components/@pagination/PaginatedComment'
import { useAuthStore } from '@/store/auth'
import { useEffect, useMemo, useState } from 'react'
import { Paginated } from '@/api'
import { IBaseCommentRO } from '@/api/interfaces/IComment'

interface PaginatedFanboardPostCommentProps {
  post: IPost.IPostRO
}

export function PaginatedFanboardPostComment({
  post,
  translations,
}: WithT<PaginatedFanboardPostCommentProps>) {
  const { accessToken } = useAuthStore()

  const [initial, setInitial] = useState<Paginated<IBaseCommentRO>>()
  const params = useMemo(
    () => ({
      amount: 5,
    }),
    [],
  )

  useEffect(() => {
    const fetchInitial = async () => {
      const initial = await PostApi(accessToken).paginateComment(
        post.id,
        params,
      )
      setInitial(initial)
    }
    fetchInitial()
  }, [post.id, params, accessToken])

  if (!initial) return

  return (
    <PaginatedComment
      domainId={post.id}
      params={params}
      initial={initial}
      functions={{
        like: PostApi(accessToken).likeComment,
        delete: (id, domainId) =>
          PostApi(accessToken).deleteComment(domainId, id),
        update: PostApi(accessToken).updateComment,
        create: PostApi(accessToken).createComment,
        loadMore: (parentId, articleId) =>
          PostApi(accessToken)
            .paginateComment(articleId, {
              amount: 5,
              parentId,
            })
            .then((res) => res.rows),
        paginate: PostApi(accessToken).paginateComment,
      }}
      translations={translations}
      showCount
    />
  )
}
